/* global G, PLATFORM */
/* eslint-disable no-shadow,no-unused-vars */
import { curry, deleteKey, getFirstItem, setKey } from 'lib/util'
import { get } from 'lib/sequence/component/state/value'
import {
  back,
  detail,
  list,
  persistChange,
  persistCheck,
  persistOptions,
  persistScroll,
  redirect,
} from 'app/_shared/events'
import { jump as jumpBack, list as listBreadcrumbs } from 'app/_shared/events/breadcrumbs'
import { getBreadcrumbs, getNode, getNodeType, getTree, setTree } from 'app/_shared/events/file'
import getHierarchy from 'app/_shared/events/file/node/getHierarchy'
import fetchTree from 'app/_shared/events/file/tree/fetchTree'
import remember from 'app/_shared/events/remember'
import mixed from 'app/_shared/events/search/mixed'
import searchTree from 'app/_shared/events/search/tree'
import isInName from 'app/_shared/events/search/tree/predicates/isInName'
import isInOrderNumber from 'app/_shared/events/search/tree/predicates/isInOrderNumber'
import soon from 'app/_shared/events/soon'
import { apply as applyAttachments, add as addAttachment, remove } from 'app/_shared/events/attachment'
import { chain, sublist } from 'app/_shared/events/util'
import openElectricDiagram from 'app/equipmentInformation/event/openElectricDiagram'
import getDocumentationTree from 'app/equipmentInformation/event/tree/getDocumentationTree'
import { persistUnsaveChange } from 'app/_shared/events/persist/change'
import isProduct from 'app/equipmentInformation/event/tree/filter/isProduct'
import isDocType from 'app/equipmentInformation/event/tree/filter/isDocType'
import findInitialNode from 'app/equipmentInformation/event/tree/findInitialNode'
import trimAttachmentName from 'app/equipmentInformation/event/tree/trimAttachmentName'
import hasFilter from 'app/equipmentInformation/event/tree/filter/hasFilter'
import { filterTreeAndCleanup } from 'app/_shared/events/file/tree/filterTree'
import getDrilldownTree from 'app/equipmentInformation/event/tree/getDrilldownTree'
import getTreeSteps from 'app/equipmentInformation/event/tree/getTreeSteps'
import getDrilldownNodeLabel from 'app/equipmentInformation/event/tree/getDrilldownNodeLabel'
import setLabels, { setLabelsWith } from 'app/_shared/events/file/tree/setLabels'
import setIcons, { setIconsWith } from 'app/_shared/events/file/tree/setIcons'
import getEquipmentAndRedirect from 'app/equipmentInformation/event/tree/getEquipmentAndRedirect'
import listDecisionOptions from 'app/_shared/events/collection/listDecisionOptions'
import aggregateDocumentation from 'app/dashboard/event/tdp/aggregateDocumentation'
import getFavorite from 'app/_shared/events/favorite/get'
import { openModalWith } from 'app/_shared/events/modal/open'
import { closeModalWith } from 'app/_shared/events/modal/close'
import { submitModalWith } from 'app/_shared/events/modal/submit'
import toggleFavorite, {
  toggleFavoriteFromAttachment,
  toggleFavoriteFromAttribute,
} from 'app/_shared/events/favorite/toggle'
import toggleFeedbackFromAttachment from 'app/_shared/events/feedback/toggle'
import saveTreeInActionState from 'app/_shared/events/file/tree/saveTreeInActionState'
import getHotspotTree from 'app/_shared/events/file/tree/getHotspotTree'
import routeComposition from 'trait/composition/route'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import getAttachmentInfo from 'app/equipmentInformation/event/tree/getAttachmentInfo'
import setParentNodeOrBack from 'app/_shared/events/file/tree/setParentNodeOrBack'
import getNodeOrRedirectToDetail from 'app/equipmentInformation/event/tree/getNodeOrRedirectToDetail'
import { empty } from 'lib/util/object'
import showDialog, { showBlockingDialog } from 'app/_shared/events/dialog'
import saveSetAttachment from 'app/equipmentInformation/event/tree/saveSetAttachment'
import { _url } from 'app/_shared/events/link'
import getNodeAttachment from 'app/_shared/events/file/node/getNodeAttachment'
import getComponentAttachment from 'app/equipmentInformation/event/getComponentAttachment'
import setSearchInTree from 'app/_shared/events/file/tree/setSearchInTree'
import addPosition from 'app/cart/event/position/add'
import listPersonalOptions from 'app/_shared/events/collection/listPersonalOptions'
import byKey from 'app/_shared/events/action/byKey'
import listCountries from 'app/_shared/events/collection/listCountries'
import listUserCountries from 'app/_shared/events/collection/listUserCountries'
import listInstallationReportStatus from 'app/_shared/events/collection/listInstallationReportStatus'
import persistStore, { persistChangeStore } from 'app/_shared/events/combined/persistStore'
import persistCheckAndAction from 'app/_shared/events/combined/persistCheckAndAction'
import { pdfAsAttachmentWithObfuscation, pdfWithObfuscation } from 'app/_shared/events/file/pdf'
import openChat from 'app/equipmentInformation/event/openChat'
import listStates from 'app/_shared/events/collection/listStates'
import update from 'app/_shared/events/util/update'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import focusNext from 'app/_shared/events/field/focusNext'
import getAssemblyIcon from 'app/equipmentInformation/event/getAssemblyIcon'
import { acl } from 'app/_shared/events/acl'
import logAccess from 'app/_shared/events/log/access'
import { findGroup } from 'lib/util/attachment'
import find from 'lib/sequence/component/children/find'
import clearGroupAndBack from 'app/equipmentInformation/event/clearGroupAndBack'

export default {
  acl: {
    acl,
  },
  onOpen: {
    mixed,
    mixedAndAggregate: curry(async (module, component, event) => {
      const result = await mixed(module, component, event)
      return aggregateDocumentation(module, component, { ...event, detail: { result } })
    }),
    getTree,
    getTreeSteps,
    getDocumentationTree,
    getDrilldownTree,
    fetchTree,
    getInstalledInEquipments: curry((module, component, event) => {
      const { installedIn } = find(module[G.STATE][G.ACTION][G.COMPONENT])
      const equipments = get(installedIn)

      return (equipments || []).map((p, i) => ({ key: i, value: p }))
    }),
    getHotspotTree,
    listBreadcrumbs,
    listInstallationReportStatus,
    listCountries,
    listStates,
    listWithRefs: list(null),
    listEquipmentImages: curry(async (module, component, event) => {
      const attachments = await list(null, module, component, event)
      const { filter: { type = [] } = {} } = component[G.PROPS] || {}

      return !type.length
        ? attachments
        : attachments.filter(attachment => type.some(t => attachment?.value?.mimetype?.includes?.(t)))
    }),
    countEquipmentImages: curry(async (module, component, event) => {
      const { [G.EVENTS]: eventBus } = module[G.ADAPTER]

      const attachments = await list(null, module, component, event)
      const images = attachments.filter(attachment => attachment?.value?.mimetype?.includes?.('image'))

      images.length && eventBus.dispatch(eventBus.type(G.ATTACHMENT, G.CACHE, findGroup(module)), {
        [G.DATA]: {
          [G.DATA]: images,
        },
      })

      return images?.length || 0
    }),
    openElectricDiagram,
    pdf: pdfWithObfuscation,
    pdfAsAttachment: pdfAsAttachmentWithObfuscation,
    getFavorite,
    logAccess,
  },
  onSubmit: {
    focusNext: focusNext(null),
  },
  onTree: {
    setTree,
    substituteIconsAndSetTree: curry((module, component, event) => {
      const treeWithIcons = setIcons(module, component, event)
      const treeWithLabels = setLabelsWith({
        key: 'name',
        source: 'name',
        target: 'name',
      }, module, component, treeWithIcons)

      return setTree(module, component, treeWithLabels)
    }),
    substituteAndSetTree: curry((module, component, event) => {
      const treeWithIcons = setIcons(module, component, event)
      const treeWithLabels = setLabels(module, component, treeWithIcons)

      return setTree(module, component, treeWithLabels)
    }),
    substituteDrilldownAndSetTree: curry((module, component, event) => {
      const treeWithIcons = setIconsWith({ target: 'productType' }, module, component, event)
      const treeWithLabels = setLabelsWith({
        source: 'productType',
        target: 'value',
      }, module, component, treeWithIcons)

      return setTree(module, component, treeWithLabels)
    }),
  },
  onBreadcrumbs: {
    getBreadcrumbs,
  },
  onNode: {
    getNode,
    getNodeOrRedirectToDetail,
  },
  onNodeType: {
    getNodeType,
  },
  onNodeLabel: {
    getDrilldownNodeLabel,
  },
  onNodeHierarchy: {
    getHierarchy,
  },
  onSkip: {
    getEquipmentAndRedirect,
  },
  onAttachment: {
    addAttachment,
    trimAttachmentName,
    getNodeAttachment,
    getEquipmentName: curry((module, component, event) => {
      const { equipment } = module[G.MODEL][G.CHILDREN]
      const cache = equipment[G.CACHE] || {}

      const { [G.SESSION]: { [G.STATE]: { [G.LANGUAGE]: language = 'en' } = {} } = {} } = module[G.ADAPTER]

      const serial = cache?.serialLong
        ? cache.serialLong.slice(-7)
        : cache.serial || ''

      return `${serial}_${language}`
    }),
    getFileAttachment: getComponentAttachment('file'),
  },
  onTreeSearch: {
    searchTree: searchTree([
      isInName,
    ]),
    searchPartInTree: searchTree([
      isInName,
      isInOrderNumber,
    ]),
  },
  onAddPart: {
    addPartToCart: addPosition(null),
  },
  onDocumentation: {
    redirectToDocumentationForPart: curry(async (module, component, event) => {
      try {
        const { detail } = event
        const moduleState = module[G.STATE]
        const { route: { documentation: route } } = component[G.CONFIGURATION]
        moduleState[G.ROUTE] = routeComposition(route.module, route.action)
        await redirectSequence(module)({ detail })
      } catch (e) {
        console.error(e)
      }
    }),
  },
  onSearch: {
    setSearchInTree,
    refreshList: chain(
      curry(async (module, component, event) => {
        const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
        const { tabs } = find(actionComponent)

        tabs[G.CHILDREN].map(async (tab) => {
          const { searchField, list } = find(tab)
          const term = get(searchField)

          setKey({ ...list[G.STATE][G.META], term }, G.META, list[G.STATE])
          setKey({}, 'reload', list[G.STATE])
        })
      }),
      update,
    ),
  },
  onChange: {
    noop: (m, c, e) => {},
    unsavePersistTreeAndRemember: chain(
      persistUnsaveChange,
      saveTreeInActionState,
      remember,
    ),
    persistChangeStore,
    persistStore,
    persistChange,
    persistUnsaveChange,
    persistCheck,
    persistCheckAndAction,
    persistCountry: curry(async (module, component, componentInfo, attributeInfo, event) => await chain(
      persistOptions,
      displayState('state', 'country', componentInfo, attributeInfo),
      displayHouseNumber('number', 'street', componentInfo, attributeInfo),
      update,
    )(module, component, event)),
    persistStates: persistOptions,
    addAttachment,
  },
  onCart: {
    redirectToCart: curry(async (module, component, event) => {
      try {
        const { detail } = event
        const moduleState = module[G.STATE]
        const { route: { cart: route } } = component[G.CONFIGURATION]
        moduleState[G.ROUTE] = routeComposition(route.module, route.action)
        await redirectSequence(module)({ detail })
      } catch (e) {
        console.error(e)
      }
    }),
  },
  onBack: {
    setParentNodeOrBack,
  },
  onClick: {
    back,
    clearGroupAndBack,
    uploadImagesAndBack: curry(async (module, component, event) => {
      const eventBus = module[G.ADAPTER][G.EVENTS]

      try {
        const { group } = component[G.PROPS]
        const attachments = !group ? [] : await new Promise((resolve) => {
          eventBus.add(eventBus.type(G.ATTACHMENT, G.DONE, group), (attachmentEvent) => {
            resolve(attachmentEvent?.detail?.[G.DATA] || [])
          }, { once: true })
          eventBus.dispatch(eventBus.type(G.ATTACHMENT, G.CACHE, group), { [G.DATA]: {} })
        })

        if (attachments.filter(a => !a._rev).length) {
          setKey(module[G.MODEL][G.STATE][G.REF], G.REF, component[G.STATE])
          setKey('equipment', G.API, component[G.STATE])

          await applyAttachments(module, component._name, event)
          await back(module, component, event)
        }
      } catch (e) {
        console.error(e)
      }
    }),
    redirect,
    redirectIfEquipmentHasImages: curry(async (module, component, event) => {
      try {
        const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
        const componentName = PLATFORM === 'web'
          ? 'equipmentImagesWeb'
          : 'equipmentImagesMobile'
        const { [componentName]: equipmentImages } = find(actionComponent)

        const attachments = get(equipmentImages)
        attachments && redirect(module, component, event)
      } catch (e) {
        console.error(e)
      }
    }),
    redirectOrShowDialog: curry(async (module, component, event) => {
      const { equipment = {} } = module[G.MODEL]?.[G.CHILDREN] || {}
      const equipmentCache = equipment?.[G.CACHE] || {}

      if (!empty(equipmentCache?.schematic || {})) {
        await redirect(module, component, event)
      } else {
        await showDialog(module, component, {
          title: {
            ns: 'equipmentInformation',
            key: 'dialog.noElectricDiagram.title',
            defaultValue: 'Error',
          },
          text: {
            ns: 'equipmentInformation',
            key: 'dialog.noElectricDiagram.text',
            defaultValue: 'None or more than one schematic found',
          },
          cancel: false,
        })
      }
    }),
    // redirectToArticleDetail: curry(async (module, component, event) => {
    //   const { article } = module[G.MODEL][G.CHILDREN]
    //   const { route } = component[G.CONFIGURATION]
    //   article[G.STATE][G.REF] = route.ref
    //   await redirect(module, component, event)
    // }),
    // redirectToEquipmentDetail: curry(async (module, component, event) => {
    //   const { equipment } = module[G.MODEL][G.CHILDREN]
    //   const { route } = component[G.CONFIGURATION]
    //   equipment[G.STATE][G.REF] = route.ref
    //   await redirect(module, component, event)
    // }),
    addPartToCart: addPosition(null),
    detail,
    soon,
    jumpBack,
    toggleFavorite,
    remove,
    showFeedback: openModalWith('feedbackModal'),
    toggleEquipmentFavorite: toggleFavoriteFromAttribute('equipment'),
    toggleAttachmentFavorite: toggleFavoriteFromAttachment('file'),
    toggleAttachmentFeedback: toggleFeedbackFromAttachment('file'),
    togglePartFavorite: toggleFavoriteFromAttribute('article'),
    feedback: submitModalWith('submitFeedback'),
    favorite: submitModalWith('submitFavorite'),
    saveSetAttachment,
    resetAddressAndSubmitReport: chain(
      curry((module, component, event) => { deleteKey('installationReport', module[G.STATE][G.ACTION][G.STATE]) }),
      byKey('installationReportSubmit'),
    ),
    openChat,
  },
  onLinkClick: {
    getDeepLink: curry((module, component, event) => {
      const { attachment = {} } = event.detail || event || {}
      const ref = attachment?.documentationId || attachment?.value?.documentationId

      return _url(null, module, component, { ref })
    }),
  },
  onClose: {
    back,
    redirect,
    clearGroupAndBack,
    resetFeedback: closeModalWith('feedbackModal'),
    resetFavorite: closeModalWith('favoriteModal'),
  },
  onFeedbackOpen: {
    showFeedback: openModalWith('feedbackModal'),
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
    remember,
  },
  onInitialNode: {
    findInitialNode,
  },
  onFavoriteOpen: {
    getFavorite,
  },
  onFavoriteClick: {
    toggleFavorite,
  },
  onDescriptionOpen: {
    getAttachmentInfo,
  },
  onAttachmentClick: {
    showBlockingDialog: curry((module, component, event) => showBlockingDialog(module, component, event)),
  },
  getSelection: {
    listConsentOptions: sublist([1], listDecisionOptions, false),
    listHelpfulOptions: sublist([1, 0], listDecisionOptions, false),
    listInstalledByOptions: listPersonalOptions,
    listUserCountries,
  },
  getIcon: {
    getAssemblyIcon,
  },
  filter: {
    isProduct: filterTreeAndCleanup([
      isProduct('equipment'),
    ]),
    isProductAndCleanup: filterTreeAndCleanup([
      isProduct('equipment'),
      hasFilter('equipment', ['energy', 'size', 'type']),
    ]),
    isProductAndErrorTreesAndCleanup: filterTreeAndCleanup([
      isProduct('equipment'),
      isDocType('errorTree'),
      hasFilter('equipment', ['energy', 'size', 'type']),
    ]),
    isProductAndBulletinAndCleanup: filterTreeAndCleanup([
      isProduct('equipment'),
      isDocType('bulletin'),
      hasFilter('equipment', ['energy', 'size', 'type']),
    ]),
    isServiceReferenceAndCleanup: filterTreeAndCleanup([
      isDocType('serviceReference'),
    ]),
  },
}
